import { makeStyles } from '@material-ui/core/styles';

import { COLORS, FONTS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      color: COLORS.gray.black,
      flex: '1',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    },
    panel: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      width: 320,
      paddingLeft: 20,
      paddingRight: 20,

      [theme.breakpoints.up('sm')]: {
        width: 480,
        padding: theme.spacing(5),
      },
    },
    title: {
      textAlign: 'center',
      fontWeight: theme.typography.fontWeightBold,
      fontFamily: FONTS.DMSans,
      fontSize: theme.typography.pxToRem(32),
      lineHeight: theme.typography.pxToRem(36),
    },
    subtitle: {
      margin: theme.spacing(1, 0, 3),
      textAlign: 'center',
      whiteSpace: 'pre-wrap',
    },
  }),
  { name: 'UnauthenticatedPageContentLayout' }
);
